'use strict'

const state = {
  routesList: [
    {
      route: {name: 'vacancy-preferences-settings'},
      labelKey: 'vacancy.preferences.settings.general'
    },
    {
      route: {name: 'vacancy-preferences-accesses'},
      labelKey: 'common.navigation.accesess'
    },
    {
      route: {name: 'vacancy-preferences-invitation'},
      labelKey: 'common.navigation.invitation'
    },
    {
      route: {name: 'vacancy-preferences-email'},
      labelKey: 'common.navigation.emailTemplate'
    },
    {
      route: {name: 'vacancy-preferences-sms'},
      labelKey: 'common.navigation.smsTemplate'
    }
  ]
}

const getters = {
  getRoutesList (state, getters) {
    return state.routesList
  }
}

const actions = {
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
